import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GotoTop from './Components/GotoTop';
import Home from './Pages/Home';
import EventPhotos from './Pages/EventPhotos';
import './App.css';
import ScrollToHash from './Components/ScrollToHash';

function App() {
  return (
    <Router basename="/iitm-tech-summit2026">
      <GotoTop />
      <ScrollToHash />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/event-photos' element={<EventPhotos />} />
        <Route path='/event-photos/:slug' element={<EventPhotos />} />
      </Routes>
    </Router>
  );
}

export default App;